import DatabaseModel from './DatabaseModel.js';

var CondicionPago = Object.create(DatabaseModel);

CondicionPago.model = 'condicionpago';
CondicionPago.modelFront = 'condicionespago';

export default CondicionPago;